<template>
  <div class="candidate-card">
    <div class="candidate-card__info">
      <div class="candidate-card__info-wrapper">
        <router-link
          :to="{ name: devRoute, params: { id: candidate.developer_id } }"
          class="candidate-card__link"
        >
          <v-avatar
            size="64px"
            color="blue-light"
            class="candidate-card__avatar"
          >
            <img
              v-if="candidate.avatar"
              alt="Avatar"
              src="candidateData.avatar"
            >
            <span v-else class="white--text headline">
              {{ nameInitials(candidate.full_name) }}
            </span>
          </v-avatar>
        </router-link>
        <div class="candidate-card__personal-information">
          <router-link
            :to="{ name: devRoute, params: { id: candidate.developer_id } }"
            class="candidate-card__link"
          >
            <h5 class="candidate-card__name">{{ candidate.full_name }}</h5>
          </router-link>
          <p class="candidate-card__roles">
            <template v-for="role in candidate.roles">
              {{ role }}
            </template>
            <span class="candidate-card__level">{{ candidate.level}}</span>
          </p>
          <DeveloperScore :score="candidate.score" />
        </div>
      </div>

      <div v-if="candidate.rate" class="candidate-detail">
        <div class="candidate-detail__icon">
          <img src="@/assets/img/icon-money.svg" alt="Rate icon">
        </div>
        <div class="candidate-detail__wrapper">
          <label class="candidate-detail__label">Rate</label>
          <p class="candidate-detail__data">
            {{ candidate.rate }} PLN / h
          </p>
        </div>
      </div>

      <div v-if="candidate.top_skills && candidate.top_skills.length" class="candidate-detail">
        <div class="candidate-detail__icon">
          <img src="@/assets/img/icon-skills.svg" alt="Rate icon">
        </div>
        <div class="candidate-detail__wrapper">
          <label class="candidate-detail__label">Top skills</label>
          <p class="candidate-detail__data">
            <template v-for="skill in candidate.top_skills">
              {{ skill }},
            </template>
          </p>
        </div>
      </div>
    </div>

    <div class="candidate-card__actions">
      <div class="candidate-card__menu">
        <v-menu v-if="menu" left min-width="100">
          <template v-slot:activator="{ on }">
            <v-btn icon color="secondary" v-on="on">
              <v-icon large>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>

          <slot name="menu"></slot>
        </v-menu>
      </div>

      <div :class="['candidate-card__status',
        `candidate-card__status--${serializedStatus(candidate.status)}`]"
      >
        {{ candidate.status }}
      </div>
    </div>

  </div>
</template>

<script>
import DeveloperScore from '@/components/Developers/DeveloperScore.vue';

export default {
  components: {
    DeveloperScore,
  },

  props: {
    candidate: {
      type: Object,
      required: true,
    },

    select: {
      type: Boolean,
      required: false,
      default: false,
    },

    menu: {
      type: Boolean,
      required: false,
      default: true,
    },

    devRoute: {
      type: String,
      required: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    nameInitials(name) {
      return name.split(' ').map((n) => n[0]).join('').substr(0, 2);
    },

    serializedStatus(status) {
      return status.replace(/ /g, '').toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.candidate-card {
  height: 100%;
  padding: 24px;
  background: #FFFFFF;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-shadow: 0px 3px 6px #00000029;
  border: 2px solid #fff;

  &--selected {
    border: 2px solid #6C7BE6;
  }

  &__info-wrapper {
    display: flex;
    margin-bottom: 16px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;

    @include tablet {
      align-items: flex-end;
      justify-content: space-between;
    }
  }

  &__avatar {
    margin-right: 16px;
  }

  &__name {
    font-size: 18px;
    font-weight: bold;
    line-height: 21px;
    color: $main--headers;
    margin-bottom: 4px;
  }

  &__roles {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 4px;
  }

  &__relevant {
    background: $color--green;
    color: white;
    border-radius: 16px;
    height: 22px;
    min-width: 54px;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    line-height: 22px;
  }

  &__level {
    color: $color--blue;
  }

  &__status {
    text-transform: capitalize;
    background: $color--gray;
    padding: 8px 16px;
    font-size: 14px;
    line-height: 16px;
    border-radius: 4px;

    &--draft {
      background: $color--blue-light;
      color: $color--blue;
    }
    &--accepted {
      background: $color--green--light;
      color: $color--green;
    }
    &--offered {
      background: $color--orange-light;
      color: $color--orange;
    }
    &--rejected {
      background: $color--red-light;
      color: $color--red;
    }
    &--inverification {
      background: $color--yellow-light;
      color: $color--yellow;
      min-width: 120px;
    }
    &--contracted {
      background: $color--blue-light;
      color: $color--blue;
    }
  }

  &__link {
    text-decoration: unset !important;
  }
}

.candidate-detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0px;
  }

  &__icon {
    margin-right: 8px;
    margin-top: 10px;

    img {
      height: 24px;
      margin-right: 8px;
    }
  }

  &__label {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 0;
  }
  &__data {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 0;
    font-weight: 500;
  }
}
</style>
